module.exports = __webpack_public_path__ + "static/media/retirement-object-2-2.1e4c1baa.svg";